<template>
  <div>
    <v-col sm="12" class="d-flex justify-end mb-2">
      <v-btn v-if="$vuetify.breakpoint.mdAndUp" outlined color="success" class="mx-1 mt-2" @click="exportExcel">
        <v-icon left>mdi-file-upload-outline</v-icon>
        Xuất Excel
      </v-btn>
      <v-btn
        v-if="canAddTeacher"
        class="mx-1 mt-2"
        depressed
        dark
        color="#0D47A1"
        @click="$refs['dialog-import-excel'].openDialog()"
      >
        <v-icon left>mdi-file-download-outline</v-icon>
        Nhập Excel
      </v-btn>
      <v-btn
        v-if="canAddTeacher"
        outlined
        color="#0D47A1"
        class="mx-1 mt-2"
        @click="$refs['dialog-add-student'].openDialog()"
      >
        <v-icon left>mdi-account-plus</v-icon>
        Thêm giáo viên
      </v-btn>
    </v-col>
    <AddTeacherDialog ref="dialog-add-student" />
    <ImportTeacherDialog ref="dialog-import-excel" />
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import AddTeacherDialog from './add-teacher-dialog/index.vue'
import { getHeader } from './utils'
import utils from '@/plugins/utils'
import ImportTeacherDialog from './import-teacher-dialog/index.vue'
export default {
  components: {
    AddTeacherDialog,
    ImportTeacherDialog
  },
  computed: {
    ...mapGetters({
      groupInfo: 'salaryGroup/groupInfo'
    }),
    canAddTeacher() {
      return true
    }
  },
  methods: {
    ...mapActions('salaryGroupTeacher', ['fetchStudentsInGroup']),
    async exportExcel() {
      this.$loading.active = true
      try {
        let category = this.groupInfo.category
        let header = getHeader(category)
        header.splice(0, 1)
        header.splice(1, 0, {
          text: 'Mã số',
          value: 'code'
        })
        let excelHeader = header.map(({ text, value }) => ({ text, value }))

        excelHeader = excelHeader.filter(excel => excel.value !== 'action' && excel.value !== 'stt')
        const list = await this.fetchStudentsInGroup({
          defaultId: this.groupInfo.defaultId,
          defaultType: this.groupInfo.defaultType,
          id: this.groupInfo.id
        })
        const students = JSON.parse(JSON.stringify(list))
        let filter = this.$options.filters
        const data = students.map(item => {
          item.status = filter.teacherStatus(item.status)
          item.dob = filter.ddmmyyyy(item.dob)
          item.gender = filter.gender(item.gender)
          return item
        })
        utils.exportExcel(data, excelHeader, `Danh sách giáo viên nhóm ${this.groupInfo.title}`)
      } catch (error) {
        this.$alert.error('Đã có lỗi xảy ra: ' + error)
      } finally {
        this.$loading.active = false
      }
    }
  }
}
</script>
